export const PREVENT_POPOVER_WIDGET_CLOSE_CLASS = 'prevent-popover-widget-close';
